import { render, staticRenderFns } from "./mine_new.vue?vue&type=template&id=24255094&scoped=true"
import script from "./mine_new.vue?vue&type=script&lang=js"
export * from "./mine_new.vue?vue&type=script&lang=js"
import style0 from "./mine_new.vue?vue&type=style&index=0&id=24255094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24255094",
  null
  
)

export default component.exports